import { render, staticRenderFns } from "./assignee_select.vue?vue&type=template&id=24e80b53&"
import script from "./assignee_select.vue?vue&type=script&lang=js&"
export * from "./assignee_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assignee_select.vue"
export default component.exports